import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tekken',
  templateUrl: './tekken.component.html',
  styleUrls: ['./tekken.component.css']
})
export class TekkenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
